'use strict';
require('spectrum-colorpicker');

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    PropTypes = React.PropTypes,
    get = require('lodash/object').get,
    set = require('lodash/object').set,
    ContentUtils = require('utils/ContentUtils'),
    BasicFormGroup = require('../BasicFormGroup'),
    $ = require('jquery'), //TODO: once update react 15v, will remove this dependency
    DEFAULT_EMPTY_COLOR = '#000000';

const FormGroupColorPicker = React.createClass({displayName: "FormGroupColorPicker",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        placeHolder: PropTypes.string,
        label: PropTypes.string,
        onChange: PropTypes.func,
        messageError: PropTypes.string,
        isDark: PropTypes.bool
    }),

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
        $('#colorPickerSelected').spectrum({
            preferredFormat: 'hex',
            showPalette: true,
            chooseText: t('form_group_label_confirm_color'),
            cancelText: 'Cancel',
            palette: [
                ['#000', '#444', '#666', '#999', '#ccc', '#eee', '#f3f3f3', '#fff'],
                ['#f00', '#f90', '#ff0', '#0f0', '#0ff', '#00f', '#90f', '#f0f'],
                ['#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#cfe2f3', '#d9d2e9', '#ead1dc'],
                ['#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#9fc5e8', '#b4a7d6', '#d5a6bd'],
                ['#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6fa8dc', '#8e7cc3', '#c27ba0'],
                ['#c00', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3d85c6', '#674ea7', '#a64d79'],
                ['#900', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#0b5394', '#351c75', '#741b47'],
                ['#600', '#783f04', '#7f6000', '#274e13', '#0c343d', '#073763', '#20124d', '#4c1130']
            ]
        });
    },

    clean() {
        this.refs.colorSelected.getDOMNode().value = DEFAULT_EMPTY_COLOR;
    },

    getValue() {
        const {writerAttribute, readerAttribute} = this.props;
        const value = $('#colorPickerSelected').spectrum('get').toHexString();
        const safeWritterAttribute = writerAttribute || readerAttribute;

        const wrapper = set({}, safeWritterAttribute, value || DEFAULT_EMPTY_COLOR);
        return wrapper;
    },

    isValid() {
        const {messageError, readerAttribute} = this.props;
        const inputValue = get(this.getValue(), readerAttribute);
        const messageErrorResult = ContentUtils.isNullOrEmpty(inputValue) ? messageError : '';

        this.setState({messageError: messageErrorResult});
        return messageErrorResult === '';
    },

    /**
     * The action when change the color of beer style.
     * @param evt
     * @param index
     * @param menuItem
     * @private
     */
    _onChangeColor(evt) {
        const {onChange} = this.props;

        this.setState({
            colorSelected: evt.target.value
        });

        if (onChange) {
            onChange();
        }
    },

    _resolveValue(value, readerAttribute) {
        const inputColor = get(value, readerAttribute);

        if (ContentUtils.isNullOrEmpty(inputColor)) {
            return DEFAULT_EMPTY_COLOR;
        }

        return inputColor;
    },

    render() {
        const {isDisabled, isDark, value, readerAttribute} = this.props;
        let colorPickerClassName = 'form-group form-group-color-picker';
        if (isDark) {
            colorPickerClassName += ' is-dark';
        }
        return (
            React.createElement("div", {className: colorPickerClassName }, 
                React.createElement("input", {
                    id: "colorPickerSelected", 
                    ref: "colorSelected", 
                    type: "color", 
                    onChange:  this._onChangeColor, 
                    disabled:  isDisabled === undefined ? false : isDisabled, 
                    defaultValue:  this._resolveValue(value, readerAttribute), 
                    errorText:  get(this.state, 'messageError', '') }
                ), 
                React.createElement("label", {className: "form-group-color-picker-label", for: "colorPickerSelected"}, t('form_group_label_chance_color'))
            )
        );
    }
});

module.exports = FormGroupColorPicker;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupColorPicker/FormGroupColorPicker.jsx
 **/